import { SessionError, SessionErrorKey } from '../error.mjs';
export const getSimpleErrorMapper = ({ oldErrorName, oldErrorDescription, newErrorName, newErrorDescription, }) => ({ error, errorName, errorDescription }) => {
    if (errorName !== oldErrorName) {
        return error;
    }
    if (oldErrorDescription && !errorDescription.match(oldErrorDescription)) {
        return error;
    }
    return new SessionError(newErrorDescription || errorDescription, {
        name: newErrorName,
        cause: error,
    });
};
export const getInvalidFieldErrorMapper = ({ oldErrorName = SessionErrorKey.INPUT, oldErrorDescription, newErrorName, newErrorDescription, field, }) => ({ error, errorName, errorDescription }) => {
    if (errorName !== oldErrorName) {
        return error;
    }
    if (oldErrorDescription && !errorDescription.match(oldErrorDescription)) {
        return error;
    }
    return new SessionError(newErrorDescription || errorDescription, {
        name: newErrorName,
        cause: error,
        extra: { invalidFields: { [field]: newErrorDescription || errorDescription } },
    });
};
export const getInvalidFieldsErrorMapper = (newErrorName) => ({ error, errorName }) => {
    var _a, _b;
    if (errorName !== SessionErrorKey.INPUT)
        return error;
    const invalidFields = ((_b = (_a = error === null || error === void 0 ? void 0 : error.extra) === null || _a === void 0 ? void 0 : _a.httpResponseBody) === null || _b === void 0 ? void 0 : _b.invalidAttributes) || {};
    return new SessionError('Attributes validation error.', {
        name: newErrorName,
        extra: { invalidFields },
        cause: error,
    });
};
export const combineErrorMappers = (mappers) => ({ error, errorName, errorDescription }) => {
    for (let i = 0; i < mappers.length; ++i) {
        const newError = mappers[i]({ error, errorName, errorDescription });
        if (newError !== error)
            return newError;
    }
    return error;
};
export const mapKeycloakError = (error, errorMappers) => {
    var _a, _b, _c, _d;
    if (!(error instanceof SessionError)) {
        return error;
    }
    const errorKey = (_b = (_a = error === null || error === void 0 ? void 0 : error.extra) === null || _a === void 0 ? void 0 : _a.httpResponseBody) === null || _b === void 0 ? void 0 : _b.error;
    const errorName = error.name;
    const errorDescription = ((_d = (_c = error === null || error === void 0 ? void 0 : error.extra) === null || _c === void 0 ? void 0 : _c.httpResponseBody) === null || _d === void 0 ? void 0 : _d.error_description) || '';
    if (errorKey && errorMappers[errorKey]) {
        return errorMappers[errorKey]({ error, errorName, errorDescription });
    }
    return error;
};
